// routing
import Routes from 'routes';
// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';

// providers
import { AuthProvider } from 'contexts/AuthContext';
import { PowerbiProvider } from 'contexts/PowerbiContext';
import { PermissionProvider } from 'contexts/PermissionContext';

// ==============================|| APP ||============================== //

const App = () => (
    <ThemeCustomization>
        <Locales>
            <NavigationScroll>
                <AuthProvider>
                    <PermissionProvider>
                        <PowerbiProvider>
                            <>
                                <Routes />
                                <Snackbar />
                            </>
                        </PowerbiProvider>
                    </PermissionProvider>
                </AuthProvider>
            </NavigationScroll>
        </Locales>
    </ThemeCustomization>
);

export default App;
